(function () {

    'use strict';
    angular.module('iplusjs.mapper.objectType', [
        'iplusjs.utils.objectType'
    ])
    .directive('iplusjsObjectTypeMapper', objectTypeMapper);

    objectTypeMapper.$inject = [
        'ObjectTypeUtilsService'
    ];
    function objectTypeMapper(ObjectTypeUtilsService) {
        return {
            restrict: 'A',
            require: 'ngModel',
            priority: 1000,
            scope: {
                objectType: '@iplusjsObjectTypeMapper',
                typeIdentifier: '@iotmTypeIdentifier',
                typeValue: '@iotmTypeValue',
                valueProperty: '@iotmValueProperty'
            },
            link: function ($scope, $element, $attr, $ngModel) {
                var obj = {};

                function toModel(value) {
                    obj[$scope.valueProperty] = value;
                    obj[$scope.typeIdentifier] = $scope.typeValue;

                    return ObjectTypeUtilsService.create($scope.objectType, obj);
                }

                function toView(value) {
                    if (angular.isObject(value)) {
                        return value[$scope.valueProperty];
                    } else {
                        return value;
                    }
                }

                $ngModel.$parsers.push(toModel);
                $ngModel.$formatters.push(toView);
            }
        };
    }
})();
